"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const Row = ({ onClick, children }) => {
    return (React.createElement("div", { style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '24px 0 23px',
            borderBottom: `1px solid ${src_1.titanium}`,
        }, onClick: onClick }, children));
};
exports.default = Row;
